import script from "./avatarGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./avatarGroup.vue?vue&type=script&lang=ts&setup=true"

import "./avatarGroup.vue?vue&type=style&index=0&id=2e23e57c&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e23e57c"]])

export default __exports__